import React, { useState, useEffect } from "react";
import PageTopHeadTitleBread from '../Components/PageTopHeadTitleBread';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';
import { ToastContainer } from 'react-toastify';
import InventoryTable from "./InventoryTable";

const InventoryDashboard = () => {
    const distID = localStorage.getItem('distributorId');
    const [showProductsWithBatch, setShowProductsWithBatch] = useState(false);
    const { data, error, isLoaded } = GetRequest(`/Inventory/GetInventory/${distID}/${showProductsWithBatch ? 'onlyWithStock' : 'allProducts'}`);

    const [activeFilter, setActiveFilter] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    useEffect(() => {
        if (isLoaded && data?.result) {
            applyFilters(activeFilter, searchTerm);
        }
    }, [isLoaded, data, activeFilter, searchTerm]);

    const applyFilters = (filter, term) => {
        let filtered = data?.result || [];

        if (filter !== "all") {
            filtered = filtered.filter(item => item.id.toString() === filter);
        }

        if (term) {
            filtered = filtered.filter(item => item.name.toLowerCase().includes(term));
        }

        setFilteredData(filtered);
    };

    const handleFilterClick = (filter) => {
        setActiveFilter(filter);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };

    const toggleBatchFilter = () => {
        setShowProductsWithBatch(prevState => !prevState);
    };

    if (error) {
        return <Error data="Inventory" />;
    }

    if (!isLoaded) {
        return <Loading />;
    }

    return (
        <>
            <section className="content">
                <input type="hidden" id='hdnSelectedProductItemId' />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card noUI" id="inventoryPanelUI">
                                <div className="card-header d-flex align-items-center gap-2">
                                    <button
                                        className={`form-control flBtn listfilterhead ${activeFilter === "all" ? "active" : ""}`}
                                        onClick={() => handleFilterClick("all")}
                                    >
                                        All
                                    </button>
                                    {data.result.map((item) => (
                                        <button
                                            key={item.id}
                                            className={`form-control flBtn listfilterhead ${activeFilter === item.id.toString() ? "active" : ""}`}
                                            onClick={() => handleFilterClick(item.id.toString())}
                                        >
                                            {item.name}
                                        </button>
                                    ))}
                                </div>

                                <div className="card-header d-flex align-items-center gap-2">

                                    <button
                                        className={`btn ${showProductsWithBatch ? "btn-success" : "btn-secondary"}`}
                                        onClick={toggleBatchFilter}
                                    >
                                        {showProductsWithBatch ? "📦 Show All" : "🛒 Show Stock"}
                                    </button>

                                </div>

                                <InventoryTable data={{ result: filteredData }} />
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer limit={1} />
            </section >
        </>
    );
}

export default InventoryDashboard;
